import * as z from 'zod'
import { Driver } from '~/shared/api'

export const formSchema = Driver.schema.pick({
  lastName: true,
  firstName: true,
  phone: true,
  infoSource: true,
})

export type FormValues = z.infer<typeof formSchema>
